import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { JobType } from "../../Constants/Enums/teachers.enum";

type State = {
  firstName: string;
  middleName: string;
  lastName: string;
  gender: string;
  email: string;
  address: string;
  mobile: string;
  password: string;
  classId: number | null;
  schoolBranchId: number | null;
  schoolBlockId: number | null;
  subjects: [];
  jobType: JobType;
  baseSalary: string | null;
};
const initialState: State = {
  firstName: "",
  middleName: "",
  lastName: "",
  gender: "",
  email: "",
  address: "",
  mobile: "",
  password: "",
  classId: null,
  schoolBranchId: null,
  schoolBlockId: null,
  subjects: [],
  jobType: JobType.FULLTIME,
  baseSalary: null,
};

export const registerTeachersSlice = createSlice({
  name: "registerTeacher",
  initialState,
  reducers: {
    setFirstName: (state, action: PayloadAction<string>) => {
      state.firstName = action.payload;
    },
    setMiddleName: (state, action: PayloadAction<string>) => {
      state.middleName = action.payload;
    },
    setLastName: (state, action: PayloadAction<string>) => {
      state.lastName = action.payload;
    },
    setGender: (state, action: PayloadAction<string>) => {
      state.gender = action.payload;
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setAddress: (state, action: PayloadAction<string>) => {
      state.address = action.payload;
    },
    setMobile: (state, action: PayloadAction<string>) => {
      state.mobile = action.payload;
    },
    setPassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload;
    },
    setClassId: (state, action: PayloadAction<number | null>) => {
      state.classId = action.payload;
    },
    setSchoolBranchId: (state, action: PayloadAction<number | null>) => {
      state.schoolBranchId = action.payload;
    },
    setSchoolBlockId: (state, action: PayloadAction<number | null>) => {
      state.schoolBlockId = action.payload;
    },
    setSubjects: (state, action: PayloadAction<[]>) => {
      state.subjects = action.payload;
    },
    setJobType: (state, action: PayloadAction<JobType>) => {
      state.jobType = action.payload;
    },
    setBaseSalary: (state, action: PayloadAction<string>) => {
      state.baseSalary = action.payload;
    },
    reset: (state) => {
      state = initialState;
      return state;
    },
  },
});

export const {
  setFirstName,
  setMiddleName,
  setLastName,
  setGender,
  setEmail,
  setMobile,
  setPassword,
  setClassId,
  setSchoolBranchId,
  setSchoolBlockId,
  setSubjects,
  setAddress,
  setBaseSalary,
  setJobType,
  reset,
} = registerTeachersSlice.actions;

export const registerTeacherReducer = registerTeachersSlice.reducer;
